import { Component } from '@angular/core';
import { ActivatedRoute, UrlSegment, Router, RouterOutlet } from '@angular/router';
import { LoginService } from 'src/app/shared/services/login/login.service';
import { SessionMgmtService } from 'src/app/shared/services/session-mgmt/session-mgmt.service';
import { AccountsService } from 'src/app/shared/services/accounts/accounts.service';
import { HelpersService } from 'src/app/shared/services/helpers/helpers.service';
import * as _ from 'lodash';
import { forkJoin, map, retry, catchError, of, tap, delay } from 'rxjs';
import { ResponseAnalyticsService } from 'src/app/shared/services/response-analytics/response-analytics.service';
import { GlobalFilterService } from 'src/app/shared/services/filters/global-filter.service';
import { HeaderService } from 'src/app/shared/services/header/header.service';
import { URLS_CONST } from 'src/app/shared/constants/url-constants';
import { SidebarService } from 'src/app/shared/services/sidebar/sidebar.service';
import { AppStateService } from 'src/app/shared/services/helpers/app-state.service';
import { NgIf } from '@angular/common';
import { LitmusHeaderComponent } from '../../../shared/components/header/litmus-header.component';
import { SideBarComponent } from '../../../shared/components/side-bar/side-bar.component';
import { SideBarV2Component } from 'src/app/shared/components/side-bar-v2/side-bar-v2.component';
import { LtmsDownloadWidgetComponent } from '../../../shared/components/ltms-download-widget/ltms-download-widget.component';
import { LtmsGlobalFilterSideBarComponent } from '../../../shared/filters/ltms-global-filter-side-bar/ltms-global-filter-side-bar.component';
import { LtmsBannerComponent } from '../../../shared/components/ltms-banner/ltms-banner.component';
import { LtmsLoaderComponent } from '../../../shared/components/ltms-loader/ltms-loader.component';
import { LitmusFooterComponent } from '../../../shared/components/footer/litmus-footer.component';
import { AdminService } from 'src/app/shared/services/admin-panel/admin.service';
@Component({
    selector: 'app-default-routing',
    templateUrl: './default-routing.component.html',
    styleUrls: ['./default-routing.component.scss'],
    host: {
        class: 'router-outlate-container',
    },
    imports: [
        NgIf,
        LitmusHeaderComponent,
        // SideBarComponent,
        SideBarV2Component,
        LtmsDownloadWidgetComponent,
        LtmsGlobalFilterSideBarComponent,
        LtmsBannerComponent,
        RouterOutlet,
        LtmsLoaderComponent,
        LitmusFooterComponent,
    ]
})
export class DefaultRoutingComponent {
  accountId: string = '';
  accountDetails: any = {};
  brandListDetail: any = {};
  isSideBarEnabled: boolean = false;
  moduleConfigs: any = {};
  isInitalDataLoaded: boolean = false;
  isAccountListPage: boolean = false;
  isLoadingError: boolean = false;
  adminRules: any = [];
  constructor(
    private _route: ActivatedRoute,
    private _session: SessionMgmtService,
    private _accountService: AccountsService,
    private _helpers: HelpersService,
    private _loginService: LoginService,
    private responseAnalyticsService: ResponseAnalyticsService,
    private router: Router,
    private _filterService: GlobalFilterService,
    private headerService: HeaderService,
    private sidebarService: SidebarService,
    private appStateService: AppStateService,
    private adminService: AdminService
  ) {
    this.isInitalDataLoaded = false;
    // console.log('Account DefaultRoutingComponent init');
    this.initAppData();
    this._route.queryParams.subscribe((params) => {
      if (params && params['account_id']) {
        this.isSideBarEnabled = true;
      } else {
        this.isSideBarEnabled = false;
      }
      const container = document.getElementById('accountRouterOutlet');
      if(container){
        container.scrollTop = 0;
      }
    });
  }

  // loading initial data
  initAppData() {
    this.isInitalDataLoaded = false;
    this._route.queryParams.subscribe((params) => {
      this.accountId = params['account_id'];
      let url = this.router.url;
      let routesDetails = this._helpers.prepareRouteData(url);
      // this is used  to reset universal filter while swithching between account and project or filter is applied.
      this._helpers.resetUniversalFilter(true);
      if (this.accountId) {
        this.accountId = params['account_id'];
        this.appStateService.updateIsAccount("account"); 
        this.isAccountListPage = false;
        const helpers = this._helpers.helpers;
        if (!helpers['accountDetails'] && !helpers['brandListDetail']) {
          this.isInitalDataLoaded = false;
          this.getInitialData(routesDetails);
        } else {
          if (
            helpers['accountDetails'] &&
            helpers['accountDetails']._id &&
            helpers['accountDetails']._id == this.accountId &&
            helpers['brandListDetail'] &&
            helpers['brandListDetail'].length > 0 &&
            helpers['brandListDetail'][0]['account_id'] == this.accountId
          ) {
            if (!this._helpers.restorePermissionContext('account')) {
              this.isInitalDataLoaded = false;
              this.getInitialData(routesDetails);
              return;
            }
            this._filterService.prepareAndSetFilterData(
              helpers['accountDetails'],
              (filters: any) => {}
            );
            this.isInitalDataLoaded = true;
          } else {
            this.isInitalDataLoaded = false;
            this._helpers.resetAppState('account');
            this.appStateService.resetAppstate('account');  
            // console.log("Account details changed.......so need to call API, to validate the current account details.")
            this.getInitialData(routesDetails);
          }
        }
      } else {
        this.isInitalDataLoaded = true;
        this.isAccountListPage = true;
      }
    });
  }

  getInitialData(routesDetails: any) {
    const safeApiCall = (apiCall$, apiName: string) =>
      apiCall$.pipe(
        tap(() => {
          // console.log(`Fetching ${apiName}...`);
        }),
        retry({
          count: 2,
          delay: (error, retryCount) => {
            // console.log(`Retrying ${apiName}... Attempt ${retryCount + 1}/3`, error);
            return of(null).pipe(delay(2000)); // Wait 2 sec before retrying
          },
        }),
        catchError((error) => {
          // console.error(`Error fetching ${apiName}:`, error);
          return of({ error: true, code: -1, data: {} }); // Prevents crash
        })
      );
    const apiCalls = {
      accountDetails: safeApiCall(
        this._accountService.getAccountDetail(this.accountId),
        'Account Details'
      ),
      brandListDetail: safeApiCall(
        this._accountService.getBrandsList(this.accountId),
        'Brand List'
      ),
      moduleConfig: safeApiCall(
        this._accountService.getModulConfigs({ account_id: this.accountId }),
        'Module Config'
      ),
      adminRules: safeApiCall(
        this.adminService.getRules(this.accountId),
        'Admin Rules'
      ),
    };

    forkJoin(apiCalls).subscribe((response: any) => {
      const errors: any = [];
      if (
        !response.accountDetails?.error &&
        response.accountDetails.code === 0
      ) {
        this.accountDetails = response.accountDetails.data.account || {};
      } else {
        errors.push('Account Details API failed');
      }

      if (
        !response.brandListDetail?.error &&
        response.brandListDetail.code === 0
      ) {
        this.brandListDetail = response.brandListDetail.data.brands || [];
      } else {
        errors.push('Brand List API failed');
      }

      if (!response.moduleConfig?.error && response.moduleConfig.code === 0) {
        this.moduleConfigs =
          response.moduleConfig.data.module_configuration_v2 || {};
      } else {
        errors.push('Module Config API failed');
      }

      if (!response.adminRules?.error && response.adminRules.code === 0) {
        this.adminRules = response.adminRules.data.rules || [];
      } else {
        errors.push('Admin Rules API failed');
      }

      if (errors.length) {
        console.warn('Some API calls failed:', errors);
        this.isLoadingError = true;
        this.isInitalDataLoaded = true;
      } else {
        this.loadInitialData(
          this.accountDetails,
          this.resolveManagerAccess(),
          this.moduleConfigs,
          routesDetails,
          this.adminRules
        );
      }
    });
  }

  loadInitialData(
    accountDetails: any,
    managerAccess: any,
    moduleConfigs: any,
    routesDetails: any,
    adminRules: any
  ) {
    if (!_.isEmpty(accountDetails)) {
      //if (this._accountService.isLw3PermittedAccount(accountDetails)) {
        const brandIdList = _.get(accountDetails, 'brands', []);
        const resolvedAccess = !_.isEmpty(managerAccess) ? managerAccess : this.resolveManagerAccess();
        const accessArr = _.filter(resolvedAccess, (access: any) =>
          String(access?.account_id || '') === String(accountDetails._id || '')
        );
        const managerDetails = this.getManagerDetails();
        const managerEmail = _.get(managerDetails, 'manager.email_address', '');
        const isInternalUser = String(managerEmail).toLowerCase().includes('@litmusworld.com');
        const canLoadAccount =
          !_.isEmpty(accessArr) ||
          (!_.isEmpty(managerDetails) && _.isEmpty(resolvedAccess)) ||
          isInternalUser;
        if (canLoadAccount) {
          let queryParamsObject = {
            manager_type: 3,
            account_id: accountDetails._id,
          };
          const moduleConfig = !_.isEmpty(moduleConfigs)
            ? moduleConfigs
            : accountDetails.module_configuration_v2;
          // processing module configuration.
          const module_configuration_v2 = this._helpers.getFlatenModuleConfig(
            moduleConfig,
            true
          );
          const adminRulesDic = this.adminService.createPermissionDictionary(adminRules, managerEmail, accountDetails, 'account');
          this._helpers.setPermissionContext('account', adminRules, adminRulesDic, module_configuration_v2);

          // checking for sidebar active menu
          const mainMenu = _.hasIn(module_configuration_v2, 'account.mainMenu')
            ? module_configuration_v2.account.mainMenu
            : {};
          const menuItems = this._helpers.getActiveSideMenu(
            true,
            accountDetails._id,
            mainMenu
          );
          const eligiblepath =
            menuItems && menuItems.length
              ? _.map(menuItems, (item: any) => item.path)
              : [];

          this._filterService.prepareAndSetFilterData(
            accountDetails,
            (filters: any) => {}
          );
          // this._helpers.helpers['isAccount'] = true;
          let labelConfig = {}; // labelConfig data comes from brand/account
          if (accountDetails && accountDetails.label_configs) {
            labelConfig = accountDetails.label_configs;
          }
          this._helpers.setLabelConfigs(labelConfig);
          this._helpers.helpers['brandListDetail'] = this.brandListDetail;
          this._helpers.setInitialData(
            accountDetails,
            queryParamsObject,
            resolvedAccess
          );
          window['Helpers'] = this._helpers.consoleData();

          // Account main-menu eligibility redirect is intentionally disabled (legacy behavior).
          // Settings submenu access is still guarded via adminRulesDic, same as project level.
          if (
            routesDetails.routeName == 'settings' &&
            routesDetails.subRouteName !== '' &&
            routesDetails.subRouteName !== null &&
            routesDetails.subRouteName !== 'admin'
          ) {
            const isSelectedMenuActive = this._helpers.isAccountSettingsMenuVisible(
              routesDetails.subRouteName,
              this._helpers.helpers['adminRulesDic']
            );
            const settingsMenu = this._helpers.getAccountSettingsMenuItems();
            if (
              !isSelectedMenuActive &&
              settingsMenu &&
              !_.isEmpty(settingsMenu) &&
              settingsMenu.visible &&
              settingsMenu.submenu &&
              !_.isEmpty(settingsMenu.submenu)
            ) {
              const redirectUrl = 'accounts/' + settingsMenu.submenu[0].path;
              this.router.navigate([redirectUrl], {
                queryParams: {
                  account_id: accountDetails._id,
                },
              });
            } else if (!isSelectedMenuActive) {
              this.router.navigate(['message'], {
                queryParams: { status: '404' },
              });
            }
          }

          this.appStateService.collectDefaultValuesForAppState(
            this.accountDetails,
            this.brandListDetail,
            {},
            managerDetails,
            'account',
            (success) => {
              this.isInitalDataLoaded = true;
            }
          );
        } else {
          // UnauthrizedAccess
          this.isInitalDataLoaded = true;
          this.router.navigate(['message'], { queryParams: { status: '401' } });
        }
      // } else {
      //   // AccountNotAllowedOnLW3
      //   this.isInitalDataLoaded = true;
      //   this.router.navigate(['message'], { queryParams: { status: '402' } });
      // }
    } else {
      // Invaild or not found account details
      this.isInitalDataLoaded = true;
      this.router.navigate(['message'], { queryParams: { status: '403' } });
    }
  }

  private getSessionLoginResponse(): any {
    const session = this._session.getData('LOGIN_RESPONSE');
    if (!session) {
      return null;
    }
    if (typeof session === 'string') {
      try {
        return JSON.parse(session);
      } catch {
        return null;
      }
    }
    return session;
  }

  private getManagerDetails(): any {
    const fromHelpers = this._helpers.helpers['managerDetails'];
    if (fromHelpers?.manager) {
      return fromHelpers;
    }
    return this.getSessionLoginResponse();
  }

  private resolveManagerAccess(): any[] {
    const managerDetails = this.getManagerDetails();
    const fromManager = _.get(managerDetails, 'manager.manager_access', []);
    if (!_.isEmpty(fromManager)) {
      return fromManager;
    }
    const fromLoggedInManager = _.get(managerDetails, 'loggedInManager.manager_access', []);
    return !_.isEmpty(fromLoggedInManager) ? fromLoggedInManager : [];
  }

  onScroll() {
    this.responseAnalyticsService.setScrollTrigger('trigger');
  }
  reloadCurrentPage() {
    window.location.reload();
  }
}

// Need following details for Account routings
// 1. Account details - Done
// 2. Current loggedin Manager details -
// 3. Brand list with basic details (for selected account) - Done
